import api, { Header } from './base';
import {
  AllegroDeliveryMethod,
  AllegroDeliveryMethods,
  AllegroDeliveryService,
  AllegroDeliveryServices,
  AllegroOrderCarrier,
  AllegroOrderCarriers,
  AllegroShippingRate,
  AllegroShippingRateDetail,
  AllegroShippingRates,
} from './allegroApiTypes';
import {
  mockGetAllegroDeliveryMethods,
  mockGetAllegroDeliveryServices,
  mockGetAllegroOrderCarriers,
  mockGetAllegroShippingRate,
  mockGetAllegroShippingRates,
} from './mocks/allegroMock';

const BASE_PATH = 'allegro-api';

export async function getAllegroShippingRates(
  eshopCode: string,
): Promise<AllegroShippingRate[]> {
  const response = await api.get<AllegroShippingRates>(`${BASE_PATH}/sale/shipping-rates`, {
    headers: {
      [Header.X_ESHOP_CODE]: eshopCode,
      [Header.ACCEPT]: 'application/vnd.allegro.public.v1+json',
    },
  });
  return response.data.shippingRates;
}

api.mock
  .onGet('allegro-api/sale/shipping-rates')
  .reply(200, mockGetAllegroShippingRates);

export async function getAllegroShippingRate(
  eshopCode: string,
  id: string,
): Promise<AllegroShippingRateDetail> {
  const response = await api.get<AllegroShippingRateDetail>(`${BASE_PATH}/sale/shipping-rates/${id}`, {
    headers: {
      [Header.X_ESHOP_CODE]: eshopCode,
      [Header.ACCEPT]: 'application/vnd.allegro.public.v1+json',
    },
  });
  return response.data;
}

api.mock
  .onGet(/allegro-api\/sale\/shipping-rates\/.+/)
  .reply(200, mockGetAllegroShippingRate);

export async function getAllegroDeliveryMethods(
  eshopCode: string,
  signal?: AbortSignal,
): Promise<AllegroDeliveryMethod[]> {
  const response = await api.get<AllegroDeliveryMethods>(`${BASE_PATH}/sale/delivery-methods`, {
    headers: {
      [Header.X_ESHOP_CODE]: eshopCode,
      [Header.ACCEPT]: 'application/vnd.allegro.public.v1+json',
    },
    signal,
  });
  return response.data.deliveryMethods;
}

api.mock
  .onGet('allegro-api/sale/delivery-methods')
  .reply(200, mockGetAllegroDeliveryMethods);

export async function getAllegroOrderCarriers(
  eshopCode: string,
  signal?: AbortSignal,
): Promise<AllegroOrderCarrier[]> {
  const response = await api.get<AllegroOrderCarriers>(`${BASE_PATH}/order/carriers`, {
    headers: {
      [Header.X_ESHOP_CODE]: eshopCode,
      [Header.ACCEPT]: 'application/vnd.allegro.public.v1+json',
    },
    signal,
  });

  return response.data.carriers;
}

api.mock
  .onGet('allegro-api/order/carriers')
  .reply(200, mockGetAllegroOrderCarriers);

export async function getAllegroDeliveryServices(
  eshopCode: string,
  signal: AbortSignal,
): Promise<AllegroDeliveryService[]> {
  const response = await api.get<AllegroDeliveryServices>(`${BASE_PATH}/shipment-management/delivery-services`, {
    headers: {
      [Header.X_ESHOP_CODE]: eshopCode,
      [Header.ACCEPT]: 'application/vnd.allegro.public.v1+json',
    },
    signal,
  });

  return response.data.services;
}

api.mock
  .onGet('allegro-api/shipment-management/delivery-services')
  .reply(200, mockGetAllegroDeliveryServices);
